import React, { useEffect, useRef, useState } from "react";
import "./SideBar.css";
import ToggleTheme from "../../main-page/components/get-conversation/ToggleTheme";
import {
  handleNewConversationRequest,
  regenerateResponse,
  setIsGenerateImage,
  setIsGlobalSearch,
  setMinimizeSidebar,
  setPopupConShown,
  setShowNavMenu,
  setShowSignPopup,
  setUpLoadedFile,
} from "../../../store/one-query/chatsSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { conversationsActions } from "../../../store/one-query/conversationSlice";
import { useNavigate } from "react-router-dom";
import SignInPopup from "./SignInPopup";
import useNavigateToMainPage from "../../../NavigateToMainPage";
import { OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import MenuIcon from "../../../Custom-imeges/MenuIcon";
import CloseMenuIcon from "../../../Custom-imeges/CloseMenuIcon";
import AddIcon from '@mui/icons-material/Add';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  ClickAwayListener,
  IconButton,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Tooltip as MuiTooltip} from "@mui/material";
import WorkflowsIcon from "../../../Custom-imeges/WorkflowsIcon";
import { AppsIcon } from "../../../Custom-imeges/SuitesIcons/AppsIcon";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import LibraryIcon from "../../../Custom-imeges/LibraryIcon";


function SideBar() {
  const isPopupConShown = useAppSelector((s) => s.ChatsState.popupSaveConShown);
  const isNewConversation = useAppSelector((s) => s.ChatsState.newConversation);
  const isAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const isFullWidth = useAppSelector((state) => state.ChatsState.fullWidthMode);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [showExploreApps, setShowExploreApps] = useState(false);
  const newConversation = useAppSelector(
    (state) => state.ChatsState.newConversation
  );
  const [isMobile, setIsMobile] = useState(false);
  const navigate=useNavigate()
  const showNavMenu = useAppSelector((s) => s.ChatsState.showNavMenu);
  const dispatch = useAppDispatch();
  const minimizeSidebar = useAppSelector((s) => s.ChatsState.minimizeSidebar)
  const navigateToMainPage = useNavigateToMainPage(); 
   const SuitesApps = [
      {
        appTitle: "Text suite",
        appIcon: <ArticleOutlinedIcon className="main-suites-app-icon" />,
      },
      {
        appTitle: "Image suite",
        appIcon: <ImageOutlinedIcon className="main-suites-app-icon" />,
      },
      {
        appTitle: "Video suite",
        appIcon: <VideocamOutlinedIcon className="main-suites-app-icon" />,
      },
    ];

  useEffect(() => {
    if (isAuthenticated) {
      navigateToMainPage();
    }
    handleNewConversation();
  }, [isAuthenticated]);

  useEffect(() => {
     if (isMobile) dispatch(setMinimizeSidebar(false));
   }, [isMobile]);
   
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) dispatch(setMinimizeSidebar(false));
  }, [isMobile]);
  const handleNewConversation = () => {
    dispatch(setUpLoadedFile(false));
    dispatch(regenerateResponse(false));
    dispatch(handleNewConversationRequest());
    dispatch(conversationsActions.removeActiveConversation());
  };

  const handleNewConversationClick = () => {
    if (!isPopupConShown && !isNewConversation) {
      dispatch(setShowSignPopup({show: true , type: "Save conversation" , message: "You will no longer see this conversation here. ",btnTitle:"New conversation",btnAction:"NEW_CONVERSATION"}))
      dispatch(setPopupConShown(true));
    } else {
      handleNewConversation();
      dispatch(setIsGenerateImage(false));
      dispatch(setIsGlobalSearch(false));
      navigateToMainPage();
    }
    handleCloseNavMenu()
  };

  const handleShowNavMenu = () => {
    dispatch(setShowNavMenu(true));
  };

  const handleCloseNavMenu = () => {
    dispatch(setShowNavMenu(false));
  };

    const handleMinimizeSidebar = ()=>{
    dispatch(setMinimizeSidebar(!minimizeSidebar))
  }

    const renderTooltip = (tooltipText: string | undefined) => (props: TooltipProps) => {
      return tooltipText !== "" && minimizeSidebar ? (
        <Tooltip className="get-conversation-tooltip" id="dropdown-item-tooltip" {...props}>
          <span className="persona-item-overlay">{tooltipText}</span>
        </Tooltip>
      ) : (
        <div></div>
      );
  };

  const handleClickOutside = (event: TouchEvent) => {
    if ( sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
      handleCloseNavMenu();
    }
  };
  
  useEffect(() => {
    if (showNavMenu) {
      document.addEventListener("touchstart", handleClickOutside);
    } else {
      document.removeEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showNavMenu]);
  const handleNavigateToworkflows = () => {
    navigate("/workflows");
    handleCloseNavMenu();
  };
  const handleNavigateToLibrary=()=>{
    navigate("/library");
    handleCloseNavMenu();
  }
  const handleOpenSuitesApps = () => {
    navigate("/suites");
    handleCloseNavMenu();
  };
  const toggleShowExploreApps = () => {
    if (!minimizeSidebar) {
      setShowExploreApps(!showExploreApps);
    }
  };
  const handleSelectSuiteApp = (appName: string) => {
    if (appName === "Text suite") {
      navigate("/suites");
    } else if (appName === "Image suite") {
      navigate("/suites/image-suite");
    } else if (appName === "Video suite") {
      navigate("/suites/video-suite");
    }
    handleCloseNavMenu();
    setShowExploreApps(false);
  };
  return (
    <div className={`get-conversation-container 
      ${showNavMenu ? "sidebar-container-open" : "sidebar-container-close"} ${minimizeSidebar && "minimize-sidebar"}
      ${showNavMenu && "open"}`} ref={sidebarRef}>
      <div className="sidebar-container">
        <div className="getConversations">
          <div className={`logo`}>
            <div className="menu-icon c-pointer" onClick={handleMinimizeSidebar}>
              <MenuIcon />
            </div>
            <div style={{
              display: "flex",
              alignItems: showNavMenu?"center":"start",
              marginTop:showNavMenu?"5px":undefined,
              marginBottom:"30px",
            }}>
             <div className="close-menu-container" onClick={!showNavMenu ? handleShowNavMenu : handleCloseNavMenu}>
              {!showNavMenu ? <MenuIcon /> : <CloseMenuIcon/>}
            </div>

            <div className="app-logo-container">
              <img className="expertex-logo c-pointer d-block" onClick={navigateToMainPage}/>
            </div>
            </div>
          </div>
          <>
            <div className="handle-conversationsForAnnon">
              <div className="sidebar-apps" >
              <OverlayTrigger 
                placement="right"
                delay={{ show: 250, hide: 300 }}
                overlay={renderTooltip("New conversation")}>
                  <div className={`side-nav-newConversation new`}
                      onClick={handleNewConversationClick}>
                      <div className="text">
                        <AddIcon sx={{color:'#fff', margin: '4px', fontSize:'1.4rem'}}/>
                        <p className="titleFont mb-0 new-text">New conversation</p>
                      </div>
                    </div>
              </OverlayTrigger>
              {minimizeSidebar ? (
                  <>
                  <Box className={`explore-apps-mini ${window?.location?.pathname.includes("/suites") && "active"}`}>
                    <MuiTooltip
                      title="Explore Apps"
                      placement="right"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "var(--m-background33)",
                          },
                        },
                      }}
                      onClick={handleOpenSuitesApps}
                    >
                      <IconButton>
                        <AppsIcon className="custom-icon" />
                      </IconButton>
                    </MuiTooltip>
                  </Box>
                  <Box
                      className={`explore-apps-mini ${
                        window.location.pathname.includes("/workflows") && "active"
                      }`}
                      onClick={handleNavigateToworkflows}
                    >
                      <MuiTooltip
                        title="Workflows"
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "var(--m-background33)",
                            },
                          },
                        }}
                      >
                        <IconButton>
                          <WorkflowsIcon className="custom-icon" />
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                  <Box
                      className={`explore-apps-mini ${
                        window.location.pathname.includes("/library") && "active"
                      }`}
                      onClick={handleNavigateToLibrary}
                    >
                      <MuiTooltip
                        title="Library"
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "var(--m-background33)",
                            },
                          },
                        }}
                      >
                        <IconButton>
                          <Badge
                            badgeContent={"New"}
                            sx={{
                              '& .MuiBadge-badge': {
                                width: '29px',
                                height: '14px',
                                top: '-10px',
                                left: '-10px',
                                borderRadius: '2px',
                                backgroundColor: '#12B6EA',
                                color: '#191B22',
                                padding: '1px 4px',
                                fontSize: '10px',
                                fontWeight: '700',
                              },
                            }}
                          >
                            <LibraryIcon className="custom-icon" />
                          </Badge>
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                    <div className="line"></div>
                  </>
                ) : (
                  <>
                  <ClickAwayListener
                    onClickAway={() => setShowExploreApps(false)}
                  >
                    <Box>
                      <Accordion
                        expanded={showExploreApps}
                        onChange={toggleShowExploreApps}
                        className={`apps-dropdown ${
                          showExploreApps ? "expanded" : ""
                        }`}
                        sx={{
                          backgroundColor: "transparent",
                          border: "none",
                          boxShadow: "none",
                          "&::before": { display: "none" },
                          padding: "0",
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon className="main-suites-app-icon" />
                          }
                          sx={{
                            margin: "8px 0",
                            height: "36px",
                            minHeight: "36px",
                            paddingLeft: "0",
                            "&.Mui-expanded": {
                              height: "36px",
                              minHeight: "36px",
                            },
                          }}
                        >
                          <Box className="category-header">
                            <AppsIcon className="custom-icon" />
                            <Typography className="category-name">
                              Explore Apps
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        {SuitesApps.map((app, index) => (
                          <AccordionDetails
                            key={index}
                            className="main-suites-app"
                            onClick={() => handleSelectSuiteApp(app.appTitle)}
                            sx={{ padding: "4px 16px" }}
                          >
                            <Box className="suites-app-type">
                              {app.appIcon}
                              <Typography
                                className="suites-app-name"
                                sx={{ fontSize: "12px" }}
                              >
                                {app.appTitle}
                              </Typography>
                            </Box>
                          </AccordionDetails>
                        ))}
                      </Accordion>
                    </Box>
                  </ClickAwayListener>
                  <Accordion
                      expanded={false} // Keeps expanded for styling, but no details section
                      className={`apps-dropdown${
                        window?.location?.pathname.includes("/workflows")
                          ? "active"
                          : ""
                      } ${false ? "expanded" : ""}`}
                      sx={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        "&::before": { display: "none" },
                        padding: "0",
                      }}
                    >
                      <AccordionSummary
                        className="workflows-header"
                        sx={{
                          margin: "8px 0",
                          height: "36px",
                          minHeight: "36px",
                          paddingLeft: "0",
                        }}
                        onClick={handleNavigateToworkflows} // Handles navigation & style change
                      >
                        <Box className="category-header workflows-header">
                          <WorkflowsIcon className="custom-icon" />
                          <Typography className="category-name">
                            Workflows
                          </Typography>
                        </Box>
                      </AccordionSummary>
                    </Accordion>
                  <Accordion
                      expanded={false} // Keeps expanded for styling, but no details section
                      className={`apps-dropdown ${
                        window?.location?.pathname.includes("/library")
                          ? "active"
                          : ""
                      } ${false ? "expanded" : ""}`}
                      sx={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        "&::before": { display: "none" },
                        padding: "0",
                      }}
                    >
                      <AccordionSummary
                        className="workflows-header"
                        sx={{
                          margin: "8px 0",
                          height: "36px",
                          minHeight: "36px",
                          paddingLeft: "0",
                          "& .MuiAccordionSummary-content": {
                          alignItems: "center",
                          gap: "8px",
                          },
                        }}
                        onClick={handleNavigateToLibrary} // Handles navigation & style change
                      >
                        <Box className="category-header workflows-header">
                          <LibraryIcon className="custom-icon" />
                          <Typography className="category-name">
                             Library
                          </Typography>
                          </Box>
                          <Box
                            sx={{
                            width: "29px",
                            height: "14px",
                            borderRadius: "2px",
                            backgroundColor: "#12B6EA",
                            color: "#191B22",
                            padding: "1px 4px",
                            fontSize: "10px",
                            fontWeight: "700",
                            }}
                          >
                            New
                          </Box>
                      </AccordionSummary>
                    </Accordion>
                    <div className="line"></div>
                  </>
                )}
                </div>
              <div className="d-flex flex-column gap-2 w-100 align-items-center">
                <div className="line"></div>
                <OverlayTrigger 
                    placement="right"
                    delay={{ show: 250, hide: 300 }}
                    overlay={renderTooltip("Change theme")}>
                      <div className="change-theme">
                        <ToggleTheme />
                      </div>
                  </OverlayTrigger>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
